import React, { forwardRef } from 'react';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  required?: boolean;
  helperText?: string;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  label,
  error,
  required = false,
  helperText,
  className = '',
  id,
  ...props
}, ref) => {
  const textareaId = id || props.name || Math.random().toString(36).substr(2, 9);
  
  const baseClasses = 'w-full px-4 py-2 border rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors resize-vertical';
  
  const borderClasses = error 
    ? 'border-red-300' 
    : 'border-gray-300';
    
  const textareaClasses = `${baseClasses} ${borderClasses} ${className}`.trim();

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={textareaId} className="block text-sm font-medium text-gray-700 mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      <textarea
        ref={ref}
        id={textareaId}
        className={textareaClasses}
        {...props}
      />
      
      {(error || helperText) && (
        <div className="mt-1">
          {error && (
            <p className="text-red-500 text-xs">{error}</p>
          )}
          {!error && helperText && (
            <p className="text-gray-500 text-xs">{helperText}</p>
          )}
        </div>
      )}
    </div>
  );
});

Textarea.displayName = 'Textarea';

export default Textarea;